module.exports = __webpack_public_path__ + "static/media/oval-3.34f9d351.svg";